import httpClient from "@hd/http-client/http-client";

export const logoutRequest = async () => {
  await httpClient.post<void>(
    import.meta.env.VITE_HD_API_URL + "/auth/revoke-token",
    {}
  );
};
